import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  OrderLinkFlowAccountFinaliseRequestType,
  OrderLinkFlowAccountFinaliseResponseType,
} from "@sellar-io/api-v2/types";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderLinkFlowAccountFinalise = (
  orderFlowToken: string | null,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: OrderLinkFlowAccountFinaliseRequestType) =>
      apiV2Request({
        user: undefined,
        business: null,
        method: "post",
        path: "order-link-flow/account-finalise",
        data,
        headers: {
          authorization: `Bearer ${orderFlowToken}`,
        },
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as OrderLinkFlowAccountFinaliseResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ServerStateKeys.OrderLinkFlowOrder, orderFlowToken],
      });
    },
  });
};
